import { useContext } from 'react';

import { ValidationContext, ValidationContextProps } from './validation-context';

/**
 * Retrieves the context for validating inputs. Should only be used by inputs trying to validate themselves.
 */
export function useValidationContext(): ValidationContextProps {
  return useContext(ValidationContext);
}
